import React, { useMemo } from 'react';
interface BarcodeProps {
  value: string;
  height?: number;
  showText?: boolean;
  className?: string;
}

/** Visual Code 128-style barcode (demo rendering). Payload carries only the PCR/sticker reference — no personal data. */
export function Barcode({
  value,
  height = 64,
  showText = true,
  className = ''
}: BarcodeProps) {
  const bars = useMemo(() => {
    const widths: number[] = [2, 1, 1, 2, 3, 2];
    for (let i = 0; i < value.length; i++) {
      const code = value.charCodeAt(i);
      for (let j = 0; j < 6; j++) widths.push((code * (j + 3) + i * 7) % 4 + 1);
    }
    widths.push(2, 3, 3, 1, 1, 1, 2);
    return widths;
  }, [value]);
  const total = bars.reduce((a, b) => a + b, 0);
  let x = 0;
  return <div className={`flex flex-col items-center ${className}`} data-id="element-315" data-mp="13cccc3q6pq4r">
      <svg viewBox={`0 0 ${total} 40`} preserveAspectRatio="none" className="w-full" style={{
      height
    }} role="img" aria-label={`বারকোড ${value}`} data-id="element-316" data-mp="fnb2qd5m88xw">
        {bars.map((w, i) => {
        const rect = i % 2 === 0 ? <rect key={i} x={x} y={0} width={w} height={40} fill="#0F2133" data-id="element-317" data-mp="3g5n8f2zvt7yy" /> : null;
        x += w;
        return rect;
      })}
      </svg>
      {showText && <span className="mt-1 font-mono text-xs tracking-[0.2em] text-ink" data-id="element-318" data-mp="3pwhrxzlqttgp">{value}</span>}
    </div>;
}